import { PagerMode } from 'src/app/features/shared/pager/model/pager-show-mode';
import { TabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { ISortField } from 'src/app/infrastructure/pipes/filter.pipe';
import { ITabDataRequest } from './tab-data-request';

export const tabData = {
    activeGuid: 'activeGuid',
    filterString: 'filterString',
    label: 'label',
    name: 'name',
    needRefresh: 'needRefresh',
    page: 'page',
    pagerMode: 'pagerMode',
    scrollPos: 'scrollPos',
    searchFields: 'searchFields',
    // Initiële sorteerketen van deze tab (bv. [{field: domainUserData.active, direction: 'asc'}]) —
    // zelfde soort "default tot de gebruiker zelf iets kiest" als searchFields, zie
    // TabDataService.sortFields$$ voor de fallback-logica.
    sortFields: 'sortFields',
    size: 'size',
} as const;

export type TTabData = (typeof tabData)[keyof typeof tabData];

export interface ITabData {
    [tabData.activeGuid]: string | null;
    [tabData.filterString]: string | null;
    [tabData.label]: string | null;
    [tabData.name]: TabName;
    [tabData.needRefresh]: boolean | null;
    [tabData.page]: number | null;
    [tabData.pagerMode]: PagerMode | null;
    [tabData.scrollPos]: number | null;
    [tabData.searchFields]: string[] | null;
    [tabData.sortFields]: ISortField[] | null;
    [tabData.size]: number | null;
};

export class TabData
    implements ITabData
{
    [tabData.activeGuid]: string | null = null;
    [tabData.filterString]: string | null = null;
    [tabData.label]: string | null = null;
    [tabData.name]!: TabName;
    [tabData.needRefresh]: boolean = true;
    [tabData.page]: number | null = null;
    [tabData.pagerMode]: PagerMode | null = null;
    [tabData.scrollPos]: number = 0;
    [tabData.searchFields]: string[] | null = null;
    [tabData.sortFields]: ISortField[] | null = null;
    [tabData.size]: number | null = null;

    constructor(data: Pick<ITabData, typeof tabData.name> & Partial<ITabData>) {
        this[tabData.name] = data[tabData.name];
        Object.assign(this, TabData.merge(this, data));
    }

    static merge(current: ITabData, data: Pick<ITabData, typeof tabData.name> & Partial<ITabData>): ITabData {
        const next = {...current};
        next[tabData.activeGuid]   = data[tabData.activeGuid] ?? null;
        next[tabData.filterString] = data[tabData.filterString] ?? null;
        next[tabData.label]        = data[tabData.label] ?? null;
        next[tabData.name]         = data[tabData.name];
        next[tabData.page]         = data[tabData.page] ?? null;
        next[tabData.pagerMode]    = data[tabData.pagerMode] ?? 'hidden';
        next[tabData.scrollPos]    = data[tabData.scrollPos] ??  0;
        next[tabData.searchFields] = data[tabData.searchFields] ?? [];
        next[tabData.sortFields]   = data[tabData.sortFields] ?? [];
        next[tabData.size]         = data[tabData.size] ?? 10;

        return next;
    }
};
